/**
 * @file React hook — useDatasetData.ts: form/state logic for contributor dashboard.
 */

import { useEffect, useState } from "react";
import { getSubmissionById } from "../../../../../../services/submissionService";

/** Hook: use Dataset Data. */
export const useDatasetData = (submissionId?: string) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!submissionId) return;

    const load = async () => {
      try {
        const res = await getSubmissionById(submissionId, {
          includeFormFields: true,
        });
        if (res.data?.success) {
          setData(res.data.data);
        }
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [submissionId]);

  return { data, loading };
};